<template lang="pug">
picture.image-container(
    :class="{ loaded: loaded, 'placeholder-player': placeholder === 'color' }"
  )
    source(v-for="(attrs, index) in tempSource" :key="index" v-bind="attrs")
    img(
      v-bind="{ ...lastSource, ...$attrs }"
      v-on="$listeners"
      @load="handleLoad"
    )
</template>

<script>

const bgColors = ['#A7D2CB', '#874C62', '#C98474', '#F2D388'];
const lightenColors = ['#dcedea', '#d4b2bf', '#e9cec7', '#faedcf'];
const bgIndex = Math.floor(Math.random() * bgColors.length);
const defaultSources = [{
  type: 'image/webp',
  unit: '?x-oss-process=image/format,webp',
}, {
  type: 'image/png',
  unit: '?x-oss-process=image/quality,q_80',
  loading: 'lazy',
}];

export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'empty',
    },
  },
  data() {
    return {
      loaded: false,
      bgColor: bgColors[bgIndex],
      bgColorLight: lightenColors[bgIndex],
    };
  },
  computed: {
    sources() {
      return defaultSources.map((i) => {
        const o = {};
        if (i.type === 'image/png') {
          o.src = this.src;
        }
        o.srcset = `${this.src}${i.unit}`;

        return { ...i, ...o };
      }) || [];
    },
    tempSource() {
      return this.sources.slice(0, this.sources.length - 1);
    },
    lastSource() {
      return this.sources[this.sources.length - 1] || {};
    },
  },
  methods: {
    handleLoad(ev) {
      this.$emit('load', ev);
      this.loaded = true;
    },
  },
};
</script>

  <style lang="less" scoped>
  .image-container {
    img {
      width: 100%;
      height: 100%;
    }
  }

  @keyframes placeholder {
    0% {
      background-color: v-bind(bgcolor);
    }

    50% {
      background-color: v-bind(bgcolorlight);
    }

    100% {
      background-color: v-bind(bgcolor);
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }

    100% {
      opacity: 100%;
    }
  }

  .placeholder-player {
    animation: placeholder ease-in-out 2s infinite;

    .loaded {
      animation: none;

      .img {
        animation: fadeIn linear 0.5s;
      }
    }
  }
  </style>
